import { c as _c } from "react/compiler-runtime";
import type { Dispatch, SetStateAction } from 'react';
import cn from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import { Checkbox, InputFooter, SelectBox, SelectOption, TextArea, TextField } from '@sbt-web/ui';
import { FormValidation } from '@/client/components/Detail/AdAbuse/AdAbuse';
import Labels from '@/client/components/Detail/AdAbuse/Labels';
import classes from '@/client/components/Detail/AdAbuse/components/Form/index.module.scss';
interface Props {
  item: AdItem;
  setSelectValue: Dispatch<SetStateAction<string | undefined>>;
  setTextAreaValue: Dispatch<SetStateAction<string>>;
  setClauseValue: Dispatch<SetStateAction<boolean>>;
  setEmailValue: Dispatch<SetStateAction<string>>;
  formValidation: FormValidation;
  textAreaValue: string;
  selectValue: string | undefined;
  clauseValue: boolean;
  emailValue: string;
  /**
   * Whether or not the user is anonymous:
   * if they are, they have no user_data cookie and so we ask for their email.
   * If they are logged in, we send the cookie directly instead.
   */
  isAnonymous: boolean;
}
export const AdAbuseForm = function (props) {
  const $ = _c(41);
  const {
    item,
    formValidation,
    setClauseValue,
    setTextAreaValue,
    setSelectValue,
    setEmailValue,
    textAreaValue,
    selectValue,
    clauseValue,
    emailValue,
    isAnonymous
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn(classes["ad-abuse-form"]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== item.urn) {
    t1 = <input type="hidden" name="ad_urn" value={item.urn} />;
    $[1] = item.urn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setSelectValue) {
    t2 = o => setSelectValue(o[0]?.value);
    $[3] = setSelectValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== selectValue) {
    t3 = selectValue ? [Labels.FORM.select.abuseReasons.findIndex(obj => obj.value === selectValue)] : undefined;
    $[5] = selectValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !formValidation.isReasonValid ? Labels.FORM.select.error : undefined;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: Labels.FORM.select.label
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t6 = <div className={classes["row-container"]}><SelectBox name="reason" flavor="small" valueList={Labels.FORM.select.abuseReasons as SelectOption[]} onSelect={t2} selectedIndices={t3} errorMessage={t4} placeholder={Labels.FORM.select.placeholder} nullable={true} inputHeaderProps={t5} /></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn(classes["row-container"], classes["text-area-wrapper"]);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      label: Labels.FORM.textArea.label
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !formValidation.isDescriptionValid ? Labels.FORM.textArea.error : undefined;
  let t10;
  if ($[14] !== setTextAreaValue) {
    t10 = e => setTextAreaValue(e.target.value);
    $[14] = setTextAreaValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9 || $[18] !== textAreaValue) {
    t11 = <div className={t7}><TextArea rows={4} inputHeaderProps={t8} name="description" placeholder={Labels.FORM.textArea.placeholder} maxLength={2000} value={textAreaValue} errorMessage={t9} onInputChange={t10} /></div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = textAreaValue;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== emailValue || $[21] !== formValidation.isEmailValid || $[22] !== isAnonymous || $[23] !== setEmailValue) {
    t12 = isAnonymous ? <div className={cn(classes["row-container"])}><TextField name="email" placeholder="Indirizzo email" inputHeaderProps={{
        label: Labels.FORM.email.label
      }} value={emailValue} onInputChange={e_0 => {
        setEmailValue(e_0.target.value);
      }} errorMessage={!formValidation.isEmailValid ? Labels.FORM.email.error : undefined} type="email" /></div> : null;
    $[20] = emailValue;
    $[21] = formValidation.isEmailValid;
    $[22] = isAnonymous;
    $[23] = setEmailValue;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn(classes["row-container"]);
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <>Dichiaro di aver preso visione dell'<a href="https://info.subito.it/policies/informativa-privacy-segnalazione-dsa.htm" className={classes["privacy-link"]}>informativa per il trattamento dei dati personali</a></>;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== clauseValue || $[28] !== setClauseValue) {
    t15 = <Checkbox name="clause" checked={clauseValue} onChange={setClauseValue}>{t14}</Checkbox>;
    $[27] = clauseValue;
    $[28] = setClauseValue;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== formValidation.isClauseValid) {
    t16 = !formValidation.isClauseValid && <InputFooter message={Labels.FORM.clause.error} />;
    $[30] = formValidation.isClauseValid;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = <div className={t13}>{t15}{t16}</div>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t1 || $[36] !== t11 || $[37] !== t12 || $[38] !== t17 || $[39] !== t6) {
    t18 = <div className={t0}><form className={classes.form} title="Form segnala annuncio" method="POST">{t1}{t6}{t11}{t12}{t17}</form></div>;
    $[35] = t1;
    $[36] = t11;
    $[37] = t12;
    $[38] = t17;
    $[39] = t6;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};